import type { ToasterContextType } from './types'
import { createContext } from 'react'

export const ToasterContext = createContext<ToasterContextType | undefined>(undefined)
